export const environment = {
  production: false,
  apiUrl: 'https://hci-qa.kozaca.com.ar/api',
  apiUrl_photo: 'https://hci-qa.kozaca.com.ar',

  x_api_key: 'H8Zhb6w9ZtT2xttYi5r8P0cp8l97gY33w3o',

  auth: {
    clientId: '019d6381-89d9-7367-842d-458c64a77c93',
    clientSecret: '5MOhTMgkUuY1bZjAgeliwe0mv9pd4jKYvt8IXo3e',
  },
};
